import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Header.css";
import EnquiryPopup from "../components/EnquiryPopup";
import { toast } from "react-toastify";
// import api from "../api";

export default function Header() {
  const base = process.env.PUBLIC_URL || "";
  const [isOpen, setIsOpen] = useState(false);
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userType, setUserType] = useState(null);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const storedUser = JSON.parse(localStorage.getItem("user"));
  //   setIsLoggedIn(!!storedUser);
  // }, []);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setIsLoggedIn(true);
      setUserType(storedUser.tc_tu_user_type);
    }
  }, []);

  const toggleNavbar = () => setIsOpen(!isOpen);
  const closeNavbar = () => setIsOpen(false);

  const handleLogout = () => {
    try {
      // await api.post("/logout");

      // Clear localStorage
      localStorage.removeItem("user");
      localStorage.removeItem("isLoggedIn");
      // localStorage.clear();

      toast.success("Logged out successfully!");
      setIsLoggedIn(false);
      closeNavbar();
      window.location.href = `${base}/login`;
      // window.location.href = "/login";
      // navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      toast.error("Logout failed. Please try again.");
    }
  };

  return (
    <nav className="navbar navbar-expand-lg bg-golden shadow-sm fixed-top px-3">
      <div className="container-fluid">
        {/* Logo */}
        <Link
          className="navbar-brand fw-bold text-primary"
          to="/"
          onClick={closeNavbar}
        >
          <img
            src={`${process.env.PUBLIC_URL}/logo_urbanneed.png`}
            // src={`${process.env.PUBLIC_URL}/logo_new.jpg`}
            alt="UrbanNeed Logo"
            style={{ height: "50px", marginRight: "15px" }}
          />
        </Link>

        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Nav links & buttons */}
        <div
          className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
          id="navbarNav"
        >
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link fw-bold" to="/" onClick={closeNavbar}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link fw-bold"
                to="/about"
                onClick={closeNavbar}
              >
                About Us
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link fw-bold"
                to="/services"
                onClick={closeNavbar}
              >
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link fw-bold"
                to="/faqs"
                onClick={closeNavbar}
              >
                FAQs
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link fw-bold"
                to="/blogs"
                onClick={closeNavbar}
              >
                Blogs
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link fw-bold"
                to="/contact"
                onClick={closeNavbar}
              >
                Contact
              </Link>
            </li>
          </ul>

          {/* Buttons */}
          <div className="d-flex gap-2 flex-column flex-lg-row mt-3 mt-lg-0">
            {/* <Link to="/join" className="btn btn-provider" onClick={closeNavbar}>
              Join as Provider
            </Link> */}

            <button
              className="btn btn-outline-danger"
              onClick={() => {
                setShowEnquiry(true);
                closeNavbar();
              }}
            >
              Enquiry
            </button>
            <EnquiryPopup show={showEnquiry} setShow={setShowEnquiry} />

            {!isLoggedIn && (
              <>
                <Link
                  to="/join"
                  className="btn btn-outline-warning text-primary me-2"
                  onClick={closeNavbar}
                >
                  Join as Provider
                </Link>
                <Link
                  to="/login"
                  className="btn btn-outline-secondary"
                  onClick={closeNavbar}
                >
                  Login
                </Link>
              </>
            )}

            {isLoggedIn && (
              <>
                <Link
                  to={
                    userType === "provider"
                      ? "/provider/dashboard"
                      : "/user/dashboard"
                  }
                  className="btn btn-outline-primary"
                  onClick={closeNavbar}
                >
                  My Dashboard
                </Link>
                <button className="btn btn-danger" onClick={handleLogout}>
                  Logout
                </button>
              </>
            )}

            {/* {!isLoggedIn ? (
              <>
                <Link
                  to="/login"
                  className="btn btn-outline-secondary"
                  onClick={closeNavbar}
                >
                  Login
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/user/dashboard"
                  className="btn btn-outline-primary"
                  onClick={closeNavbar}
                >
                  My Dashboard
                </Link>
                <button className="btn btn-danger" onClick={handleLogout}>
                  Logout
                </button>
              </>
            )} */}

            <Link
              to="/services"
              className="btn btn-primary"
              onClick={closeNavbar}
            >
              Book Now
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
